import { getUrlParam, windowReplaceState } from "@src/v3.0.0/lib/utils";
import { useCanvasTilesStore } from "@src/v3.0.0/store/canvas-tiles";
import { useCropperAction } from "@src/v3.0.0/store/cropper/cropper-actions";
import { useCropperStore } from "@src/v3.0.0/store/cropper/cropper-store";
import useCustomModal from "@src/v3.0.0/store/custom-modal";
import { useProduct } from "@src/v3.0.0/store/product";
import { URL_PARAM_INIT } from "@src/var";
import { useEffect, useRef, useState } from "react";

import DatGui, { DatNumber, DatSelect, DatString } from 'react-dat-gui';
import { useDatGuiStore } from "@src/v3.0.0/store/dat-gui";
import { Box } from "@mui/material";

function CropperPresetManager() {
  const cropperStore = useCropperStore();
  const cropperAction = useCropperAction();
  const {product} = useProduct();
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  const {open: mainModalIsOpen, setOpen: mainModalSetOpen} = useCustomModal();
  const updateID = useRef();
  const datStore = useDatGuiStore();

  const $zeroPreset = useRef({
    width: product?.dimension_width,
    height: product?.dimension_height,
    // width: product?.dimension_width,
    // height: product?.dimension_height*2,
    width_initial: product?.dimension_width,
    height_initial: product?.dimension_height,
    media: product?.media[currentMediaIndex]?.sku ?? product?.media[currentMediaIndex]?.name,
    // repeats: 1,
    // scale: 2.5
  });

  const initializePreset = async (opts = { zero: false }) => {
    const mutablePreset = JSON.parse(JSON.stringify($zeroPreset.current));
    await cropperStore.initPreset(mutablePreset, opts.zero);
  };

  useEffect(() => {
    initializePreset();
    if(getUrlParam(URL_PARAM_INIT, '1')) {
      mainModalSetOpen(true);
    }
  }, []);

  useEffect(() => {
    if (cropperStore?.element?.cropper) {

      /** set preset in cropper instance */
      const jsonPreset = JSON.parse(JSON.stringify(cropperStore.preset));
      cropperStore.element.cropper.preset = jsonPreset;
        
      /** update address bar with preset */
      const updateAddressBar = () => {
        windowReplaceState({ params: cropperStore.toParams() });
      };
      const timer = setTimeout(updateAddressBar, 500);
      return () => {
        clearTimeout(timer);
      }
    }
  }, [cropperStore.preset]);

  useEffect(() => {
    clearTimeout(updateID.current);
    if (cropperAction.action) {

      ;(async () => {
        const typeAction = Object.keys(cropperAction.action)[0];
        const data = cropperAction.action[typeAction];
        switch(typeAction) {
          case '_zoomRaw':
          case 'zoomTo':
          case 'zoom':
            cropperStore.animate('zoom', { func: typeAction, data });
            break;
          case 'scaleX':
            cropperStore.element.cropper.scaleX(data);
            break;
          case 'scaleY':
            cropperStore.element.cropper.scaleY(data);
            break;
          case 'perimeter':
            /** --- clear tiles --- */
            
            cropperStore.element.cropper._initFrame(true);
            const translate = await cropperStore.element.cropper._updateTranslate();
            await cropperStore.updatePreset({
              zoom: cropperStore.element.cropper._getZoomFactor(),
              ...translate,
              ...data
            });
            break;
          case 'fitCanvas':
            cropperStore.animate('center', {}, {
              complete() {
                cropperStore.animate('zoom', {
                  func: '_zoomRaw',
                  data: {
                    value: cropperStore.element.cropper._getMinZoomRatio(),
                    pivot: cropperStore.element.cropper._getContainerCenterPivot()
                  }
                })
              }
            });
            break;
          case 'centerCanvas':
            cropperStore.animate('center');
            break;
          case 'zeroAll':
            await cropperStore.setCropperChanged();
            await initializePreset({ zero: true });
            setTimeout(() => {
              cropperStore.element.cropper._initFrame(true);
              cropperStore.setCropperReady();
            }, 500);
            break;
          default:
            console.log('unhandled cropper action');
            break;
        }
        
        // useCanvasTilesStore.getState().setTiles([]);
        /** --- exit events loop --- */
        setTimeout(() => cropperAction.clear());
      })();
    }
  }, [cropperAction.action]); 

  return null;
  return (
    <Box sx={{
      position: 'fixed',
      zIndex: theme => theme.zIndex.modal,
      top: 0,
      right: 0,
      bg: 'black'
    }}>
      <DatGui data={datStore.data} onUpdate={datStore.onUpdate}>
        <DatNumber path="duration" label="duration" min={0} max={1000} step={1} />
        <DatSelect path="easing" label="easing" options={datStore.data.easings} />
      </DatGui>
    </Box>
  );
}

export default CropperPresetManager;